<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div v-if="showRecallModal" class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden">
        <form @submit.prevent="create"
              class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full p-2">
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Recall from Leave</p>
            <img class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                 src="@/assets/icons/cross-white.png" @click="close()" />
          </div>
          <transition name="fade">
            <div v-if="create_error" class="p-1 text-center text-sm w-full bg-yellow-200 text-black">
              <span style="color: #303133">{{create_error}}</span>
            </div>
          </transition>
          <transition name="fade">
            <div v-if="create_success" class="p-1 text-center text-sm w-full bg-green-200">
              {{create_success}}
            </div>
          </transition>
          <div class="grid grid-cols-1 xl:grid-cols-2 md:grid-cols-2 gap-4">
            <div class="text-sm">
              <label class="block pb-1">
                Start Date<span class="text-red-700">*</span>
                <el-popover trigger="hover" width="250" placement="top-left">
                  <el-button slot="reference" class="el-icon-info" type="text"></el-button>
                  <p><em>Start Date</em></p>
                </el-popover>
              </label>
              <input
                  v-model="info.FromDate"
                  :min="tomorrow"
                  :max="leaveEndDate"
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Start Date"
                  required
              />
            </div>

            <!-- End Date Input -->
            <div class="text-sm" v-if="info.FromDate !==''">
              <label class="block pb-1">
                End Date <span class="text-red-700">*</span>
                <el-popover trigger="hover" width="250" placement="top-left">
                  <el-button slot="reference" class="el-icon-info" type="text"></el-button>
                  <p><em>End Date</em></p>
                </el-popover>
              </label>
              <input
                  v-model="info.ToDate"
                 :min="info.FromDate"
                  :max="leaveEndDate"
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="End Date"
                  required
              />
            </div>
          </div>

          <!--  @change="handleDescriptionChange" -->
          <div class="flex justify-end p-5 gap-5">
            <button type="submit" class="bg-primary rounded-full px-10 text-sm text-white py-2">
              Recall
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
export default {
  name: "ApprovalWarning",
  props: ["showRecallModal", "setIsConfirmed", "leaveDetails"],
  components: { Loader },
  data() {
    return {
      loading: false,
      info:{
        FromDate:'',
        ToDate:'',
        TimeoffId:''
      },
      name:'',
      create_success:null,
      create_error:null,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    },
  methods: {
    close() {
      this.$emit("close");
    },

    create() {
    // Set the time to the end of the day (23:59:59). Useful for the ToDate field
      const setEndOfDay = (date) => {
        const d = new Date(date);
        d.setHours(23, 59, 59, 999); // Set hours, minutes, seconds, and milliseconds to the end of the day
        return d.toISOString();
      };
      this.info.TimeoffId=this.leaveDetails.TimeoffId
      this.info.FromDate = new Date(this.info.FromDate).toISOString()
      this.info.ToDate = setEndOfDay(this.info.ToDate);
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
          .post(
              `${this.getOrganization}/timeoff/${this.$ApiVersion}/recall`,
              JSON.stringify(this.info),
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.create_success = response.data.StatusMessage;
                  this.setIsConfirmed()
                  this.close()
                } else {
                  setTimeout(() => {
                  this.create_error = null;
                  }, 3000);
                  this.create_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                setTimeout(() => {
                  this.create_error = null;
                }, 3000);
                this.create_error = error.message;
              }
          );

    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>

